import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import InfoIconWithTooltip from '../../Common/InfoIconWithTooltip/InfoIconWithTooltip';
import LocationWrapper from '../../../CompoundComponents/LocationWrapper/LocationWrapper';
import Country from '../../../CompoundComponents/LocationWrapper/Country/Country';
import Location from '../../../CompoundComponents/LocationWrapper/Location/Location';
import Zipcode from '../../../CompoundComponents/LocationWrapper/Zipcode/Zipcode';
import RemoteJob from '../../../CompoundComponents/LocationWrapper/RemoteJob/RemoteJob';
import styles from './JobLocationInput.module.scss';
import { locationLayers } from '../../../Utils/LocationUtils';
import jobMessage from '../JobMessages';
import placeholder from '../../Placeholders/PlaceholdersMessages';

function JobLocationInput(props) {
  const {
    form,
    isPaidJobServiceEnabled,
    isCountryWideSearchEnabled,
    getFormItemLabelText,
    countryOptions,
    jobDetails,
    AppName,
    intl,
  } = props;
  const isHidden = form.getFieldValue('LocationType') !== 'Location';
  const initialCountryOptions = countryOptions?.find(option => option.Iso2Code === jobDetails.CountryCode)
    ? jobDetails.CountryCode ?? 'US'
    : jobDetails.Country ?? 'US';

  return (
    <div style={{ display: isHidden ? 'none' : 'block' }}>
      <LocationWrapper {...props} layers={locationLayers}>
        <div className={styles.locationWrapper}>
          <div className={styles.country}>
            <Country
              label={getFormItemLabelText(<FormattedMessage {...jobMessage.countryLabel} />)}
              initialValue={initialCountryOptions}
            />
          </div>
          <div className={styles.location}>
            <Location
              label={getFormItemLabelText(<FormattedMessage {...jobMessage.locationLabel} />)}
              initialValue={jobDetails.Location}
              required={isPaidJobServiceEnabled}
              disabled={isCountryWideSearchEnabled}
              placeholder={intl.formatMessage({ ...placeholder.city_StateLabel })}
            />
          </div>
          <div className={styles.zipcode}>
            <Zipcode
              label={getFormItemLabelText(<FormattedMessage {...jobMessage.postalCodeLabel} />)}
              disabled={isCountryWideSearchEnabled}
              required={isPaidJobServiceEnabled}
              initialValue={jobDetails.Zipcode}
            />
          </div>
          {!isPaidJobServiceEnabled ? (
            <>
              <div className={styles.remoteJobInput}>
                <RemoteJob initialValue={jobDetails.IsRemoteJob} />
              </div>
              <span className={styles.remoteJobInfo}>
                <span className={styles.remoteJob}>
                  <FormattedMessage {...jobMessage.remoteJobLabel} />
                </span>
                <InfoIconWithTooltip tooltipTitle={`${AppName} will source throughout the country`} />
              </span>
            </>
          ) : null}
        </div>
      </LocationWrapper>
    </div>
  );
}

export default injectIntl(JobLocationInput);
export { JobLocationInput as JobLocationInputWithoutInjectIntl };
